export default{
    poseTitle: 'Title',
    roomStatus: 'Status',
    poses:'Card Readers',
    editPose:'Edit Card Readers',
    addPose:'Add Card Readers',
    searchPoseByUnit : 'search Pose By Unit',

}